<input type="text" value="" class="heightzero" #clipboardInput>
<div class="tabcontainer-data">
  <div class="searchBlock"> 
    <div class="searchSection">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput id="searchInputBox"class="search-components textBox" type="text" [placeholder]="placeholder" [(ngModel)]="str"
          (keyup)="filterData($event, listingInput)" (focus)="searchFocus = true" (focusout)="searchFocus = false"
          autofocus />
          <div #suggestRef>
            <div #listRef class="autosuggestion block"
              *ngIf="filteredSuggestion && filteredSuggestion.length > 0">
              <ng-container *ngFor="let item of filteredSuggestion;let i = index">
                <ul>
                  <li (click)="selectAutoComplete(item)" [class.active]="i === currentSelection">
                    <ng-container *ngIf="isDataKeyValuePair">
                      <span class="name">{{item.name}}</span>
                    </ng-container>
                    <ng-container *ngIf="!isDataKeyValuePair">
                      <span class="name">{{item}}</span>
                    </ng-container>
                    <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                  </li>
                </ul>
              </ng-container>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="headingsList" >
      <div>
        <p class="topic-heading">Topics Being Followed</p>
        <ul>
          <li class="chips-data" *ngFor="let data of listData; let i=index">
            <span class="chips-item">{{data}}</span>
            <a class="close-icon">
              <span class="chips-icon" (click)="removeTopic(i, data)">x</span>
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p class="topic-heading">Suggested Topics</p>
        <ul>
          <li class="chips-data" *ngFor="let data of suggestedTopicList; let i=index">
            <span class="chips-item">{{data}}</span>
            <a class="close-icon">
              <span class="chips-icon" (click)="addTopic(data,i)">+</span>
            </a>
          </li>
        </ul>
      </div>
  </div>
</div>
